import { api } from "@/lib/axios";
import { User } from "@/types/user";

type CreationData = {
  name?: string;
  lastName?: string;
  username: string;
  password?: string;
  campaign?: string;
  role: { _id: string; name: string };
  email: string;
  phone?: string;
};

const create = (user: CreationData): Promise<User> =>
  api.post("/users", user).catch(() => null) as unknown as Promise<User>;

export default create;
